import type { IProcedure } from '../components/interfaces/procedure';

export function checkPreviousExaminationHasAssets(procedure: IProcedure | undefined) {
    if (procedure) {
        if (
            (procedure.customControlData.files && procedure.customControlData.files.length > 0) ||
            (procedure.assets && procedure.assets.length > 0)
        ) {
            return true;
        }
    }

    return false;
}
